"use client";
//#region packages/@mantine/core/src/core/utils/keys/keys.ts
function keys(object) {
	return Object.keys(object);
}
//#endregion
export { keys };

//# sourceMappingURL=keys.mjs.map